import Index from '@tunnel-components/@sharded/@widgets/slider/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/slider/index.ts